import React from 'react';

import { useTranslation } from 'react-i18next';
import { LocalizedLink } from '../primitives';



export default function TopNavBar() {
    const { t } = useTranslation('mainLayout');

    return (
        <div className='topNavBarWrap'>
            <ul className='nav'>
                <li>
                    <div className='nav-header'>{t('products')}</div>
                    <div className='topNavBarDropdown'>
                        <LocalizedLink to='/wood-stoves/'>
                            <span>{t('stoves')}</span>
                        </LocalizedLink>
                        <LocalizedLink to='/wood-inserts/'>
                            <span>{t('inserts')}</span>
                        </LocalizedLink>
                    </div>
                </li>
                <li>
                    <div className='nav-header'>{t('parts')}</div>
                    <div className='topNavBarDropdown partDropdown'>
                        <LocalizedLink to='/archives/'>
                            <span>{t('parts-only')}</span>
                        </LocalizedLink>
                        <LocalizedLink to='/accessories/'>
                            <span>{t('accessories')}</span>
                        </LocalizedLink>
                        <LocalizedLink to='/venting/'>
                            <span>{t('venting')}</span>
                        </LocalizedLink>
                    </div>
                </li>
                <li>
                    <div className='nav-header'>{t('support')}</div>
                    <div className='topNavBarDropdown supportDropdown'>
                        <LocalizedLink to='/articles/'>
                            <span>{t('articles')}</span>
                        </LocalizedLink>
                        <LocalizedLink to='/videos/'>
                            <span>{t('videos')}</span>
                        </LocalizedLink>
                        <LocalizedLink to='/warranty/'>
                            <span>{t('warranty')}</span>
                        </LocalizedLink>
                        <LocalizedLink to='/archives/'>
                            <span>{t('manuals-only')}</span>
                        </LocalizedLink>
                        <LocalizedLink to='/installer/'>
                            <span>{t('findinstaller')}</span>
                        </LocalizedLink>
                        <LocalizedLink to='/about/'><span>{t('about')}</span></LocalizedLink>
                        <LocalizedLink to='/government-incentives/'>
                            <span>{t('gov-incentives')}</span>
                        </LocalizedLink>
                        <LocalizedLink to='/contact-us/'>
                            <span>{t('contact')}</span>
                        </LocalizedLink>
                    </div>
                </li>
                <li style={{ cursor: 'pointer', padding: 0 }}>
                    <LocalizedLink
                        className='nav-header promotions'
                        to='/promotions/'
                    >
                        <span>{t('promotions')}</span>
                    </LocalizedLink>
                    <div className='topNavBarDropdown promotionDropdown'></div>
                </li>
            </ul>
        </div>
    );
}
